import { useContext, useMemo } from 'react';
import type { FieldIssueMessage, FieldIssues } from '@bliks-io/ui';
import { DraftIssuesContext } from '../useDraftIssues';

export function useNodeFieldIssues(nodeId: string): FieldIssues {
  const context = useContext(DraftIssuesContext);

  return useMemo(() => {
    const messages = new Map<string, FieldIssueMessage[]>();
    for (const { field, title, hint } of context?.issuesByNodeId.get(nodeId) ?? []) {
      if (!field) continue;
      messages.set(field, [...(messages.get(field) ?? []), { title, hint }]);
    }
    const focusRequest = context?.focusRequest;
    return {
      messages,
      focus:
        focusRequest?.nodeId === nodeId
          ? { field: focusRequest.field, id: focusRequest.id }
          : undefined,
      onFocusHandled: context?.onFocusHandled
    };
  }, [context, nodeId]);
}

/** The decision rule rows the node's issues flag. */
export function useNodeInvalidRuleIndexes(nodeId: string): ReadonlySet<number> {
  const issues = useContext(DraftIssuesContext)?.issuesByNodeId.get(nodeId);

  return useMemo(
    () => new Set((issues ?? []).flatMap((issue) => issue.ruleIndexes ?? [])),
    [issues]
  );
}
